import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Account } from '../types/Account'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import { updateAccount } from '../service/accountService'
import accountQueryKeys from './accountQueryKeys'

export const useUpdateAccount = () => {
  const { companyId } = useContextParameters()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (account: Account) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }
      return updateAccount(account, companyId)
    },
    onSuccess: updatedItem => {
      queryClient.setQueryData<Account[]>(accountQueryKeys.list({ companyId }), old => {
        if (!Array.isArray(old)) {
          return old
        }
        return old.map(item => (item.code === updatedItem.code ? updatedItem : item))
      })
    },
    onError: error => {
      console.error('Failed to update account:', error)
    }
  })
}
